/* Desktop menu draft (Oct 30): compact sticky header + Shop mega menu. >=769px only. No dependencies. */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 769px)');
  var OPEN_DELAY = 120, SWITCH_DELAY = 90, CLOSE_DELAY = 260;
  var header, spacer, scrim, ann, current = null, timer = null;
  var st = { lastY: 0, hidden: false, ticking: false };

  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init() {
    qa('[data-dm-moved]').forEach(function (el) {
      var dup = qa(el.id ? '#' + el.id : '[data-dm-scrim]').filter(function (x) { return x !== el; });
      if (dup.length) el.parentNode.removeChild(el);
    });
    header = document.querySelector('#DmHeader:not([data-dm-moved])') || document.getElementById('DmHeader');
    if (!header || header.getAttribute('data-dm-ready')) return;
    header.setAttribute('data-dm-ready', '1');
    spacer = document.querySelector('.dm-spacer');
    scrim = document.querySelector('[data-dm-scrim]:not([data-dm-moved])') || document.querySelector('[data-dm-scrim]');
    ann = document.querySelector('.announcement');

    // Move out of #PageContainer (it animates during page transitions, which breaks position:fixed).
    var pc = document.getElementById('PageContainer');
    if (pc && pc.parentNode) {
      pc.parentNode.insertBefore(header, pc); header.setAttribute('data-dm-moved', '');
      if (scrim) { pc.parentNode.insertBefore(scrim, pc); scrim.setAttribute('data-dm-moved', ''); }
    }
    header.classList.add('dm-js');
    if (spacer) spacer.classList.add('dm-js');

    qa('[data-dm-item]', header).forEach(function (item) {
      var btn = item.querySelector('[data-dm-trigger]');
      var panel = item.querySelector('[data-dm-panel]');
      if (!btn || !panel) return;
      var entry = { item: item, btn: btn, panel: panel };
      item.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { open(entry); }, current ? SWITCH_DELAY : OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (current === entry) close(false); }, CLOSE_DELAY);
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault(); clearTimeout(timer);
        if (current === entry) close(false); else open(entry);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); open(entry);
          var first = panel.querySelector('a[href]'); if (first) first.focus();
        }
      });
      item.addEventListener('focusout', function (e) {
        // Focus moving to the sticky-cart hamburger that opened this menu is not "leaving": its click toggles the menu itself.
        if (e.relatedTarget && !item.contains(e.relatedTarget) && e.relatedTarget !== opener && current === entry) close(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && current) {
        var b = opener && document.contains(opener) ? opener : current.btn;
        close(false); try { b.focus({ preventScroll: true }); } catch (x) { b.focus(); }
      }
    });
    // Pointer left the page or jumped straight into an iframe (no mouseleave fires then): close after the usual delay.
    document.addEventListener('mouseout', function (e) {
      var to = e.relatedTarget;
      if (!current || (to && !(to.tagName === 'IFRAME' && !current.item.contains(to)))) return;
      clearTimeout(timer);
      timer = setTimeout(function () { if (current && !current.item.matches(':hover')) close(false); }, CLOSE_DELAY);
    });
    document.addEventListener('click', function (e) {
      if (current && !current.item.contains(e.target)) close(false);
    });
    header.addEventListener('focusin', function () { if (st.hidden) { st.hidden = false; paint(); } warm(); });
    // Panel photos are lazy (no cost on load); fetch them once the visitor shows intent, or when the page is idle.
    header.addEventListener('pointerenter', warm);
    window.addEventListener('load', function () { setTimeout(warm, 3000); });
    st.lastY = window.pageYOffset || 0;
    paint();
  }

  // Stock Streamline menu toggles outside the new header (the hamburger in the sticky cart bar) open the Shop mega menu on
  // desktop instead of the old slide-out nav; this also brings the hidden header back. Same pattern as mobile-menu.js.
  var opener = null;
  document.addEventListener('click', function (e) {
    if (!mq.matches || !header) return;
    var t = e.target && e.target.closest ? e.target.closest('.js-toggle-slide-nav') : null;
    if (!t || header.contains(t)) return;
    var item = header.querySelector('.dm-nav__item:not(.dm-nav__item--col)[data-dm-item]') || header.querySelector('[data-dm-item]');
    var btn = item && item.querySelector('[data-dm-trigger]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    clearTimeout(timer);
    if (current && current.btn === btn) { close(false); opener = null; t.setAttribute('aria-expanded', 'false'); return; }
    btn.click();
    if (current && current.btn === btn) {
      opener = t; t.setAttribute('aria-expanded', 'true'); t.setAttribute('aria-controls', btn.getAttribute('aria-controls'));
      try { btn.focus({ preventScroll: true }); } catch (x) {}
    }
  }, true);

  var warmed = false;
  function warm() {
    if (warmed || !header || !mq.matches) return;
    warmed = true;
    qa('[data-dm-panel] img[loading="lazy"]', header).forEach(function (img) { img.loading = 'eager'; });
  }
  function place(panel) {
    if (!panel.classList.contains('dm-panel--cols')) return;
    panel.style.marginLeft = '';
    var r = panel.getBoundingClientRect(), vw = document.documentElement.clientWidth, pad = 16, shift = 0;
    if (r.right > vw - pad) shift = (vw - pad) - r.right;
    if (r.left + shift < pad) shift = pad - r.left;
    if (shift) panel.style.marginLeft = shift + 'px';
  }
  function open(entry) {
    if (current === entry) return;
    if (current) close(true);
    current = entry;
    entry.panel.hidden = false;
    entry.btn.setAttribute('aria-expanded', 'true');
    header.classList.add('is-menu-open');
    st.hidden = false; paint();
    place(entry.panel);
    void entry.panel.offsetWidth;
    entry.panel.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
  }
  function close(instant) {
    if (!current) return;
    var e = current; current = null;
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener = null; }
    e.btn.setAttribute('aria-expanded', 'false');
    e.panel.classList.remove('is-open');
    header.classList.remove('is-menu-open');
    if (scrim) scrim.classList.remove('is-on');
    if (instant) { e.panel.hidden = true; return; }
    setTimeout(function () { if (current !== e) e.panel.hidden = true; }, 170);
  }

  /* ---------- Sticky header: hide on scroll down, show on scroll up ---------- */
  function annBottom() {
    if (!ann || !ann.offsetParent) return 0;
    var b = ann.getBoundingClientRect().bottom; return b > 0 ? b : 0;
  }
  function paint() {
    if (!header) return;
    var top = annBottom(), y = window.pageYOffset || 0;
    header.style.transform = st.hidden ? 'translate3d(0,-110%,0)' : 'translate3d(0,' + top + 'px,0)';
    header.classList.toggle('is-hidden', st.hidden);
    header.classList.toggle('is-scrolled', y > 2 && !st.hidden);
  }
  function onScroll() {
    if (st.ticking) return;
    st.ticking = true;
    window.requestAnimationFrame(function () {
      st.ticking = false;
      if (!header || !mq.matches) return;
      var y = Math.max(0, window.pageYOffset || 0), dy = y - st.lastY;
      if (current) { st.lastY = y; paint(); return; }
      if (y <= annBottom() + header.offsetHeight + 80) { st.hidden = false; st.lastY = y; }
      else if (dy > 8) { st.hidden = !header.contains(document.activeElement); st.lastY = y; }
      else if (dy < -8) { st.hidden = false; st.lastY = y; }
      paint();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { if (current) place(current.panel); onScroll(); }, { passive: true });
  var onMq = function () { if (!mq.matches) close(true); onScroll(); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });
  document.addEventListener('shopify:section:load', function () { header = null; current = null; init(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
